import { Container, Image, Row, Col } from 'react-bootstrap';

import { Card } from 'react-bootstrap';
import 'holderjs';
import '../css/HomeCard.css';
import getItOnPlayStoreImg from '../img/getItGooglePlay.png';

function HomeCard() {
    return <Card className="home-card">
        <Card.Img variant="top" src="holder.js/100px400?bg=2a2025" className="card-image" />
        <div className="card-img-overlay">
            <a className="" href="#" >Space Engineers Calulator</a>
            <a href="https://play.google.com/store/apps/details?id=com.spacecastlegames.spaceengineerscalculator" target="_blank"><Image className="playstore" src={getItOnPlayStoreImg} /></a>
        </div>


    </Card >;
}

export default HomeCard;

